import { render, staticRenderFns } from "./CurrentSubscription.vue?vue&type=template&id=4924fecf&scoped=true"
import script from "./CurrentSubscription.vue?vue&type=script&lang=js"
export * from "./CurrentSubscription.vue?vue&type=script&lang=js"
import style0 from "./CurrentSubscription.vue?vue&type=style&index=0&id=4924fecf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4924fecf",
  null
  
)

export default component.exports